import { render, staticRenderFns } from "./ResultsGroups.vue?vue&type=template&id=35923cf0&"
import script from "./ResultsGroups.vue?vue&type=script&lang=js&"
export * from "./ResultsGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports